import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  GetSingleImportMutasiBank,
  reset,
} from "../../../features/importMutasiBank/ImportMutasiBankSlice";

import { Card, Form, Col, Row } from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import { formatNumber, removeTrailingZero } from "../../../helpers/helper";

const FormImportMutasiBankPage = () => {
  const [dataImportMutasiBank, setDataImportMutasiBank] = useState({});

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector(
    (state) => state.importMutasiBank
  );

  const { id } = useParams();
  const token = localStorage.getItem("token");

  // on init (call once when the page has been loaded)
  useEffect(() => {
    // call api to fetch fakultas dropdown data
    dispatch(reset());
    if (id) {
      dispatch(GetSingleImportMutasiBank({ id, token }));
    }
  }, [id, dispatch, token]);

  // init the model before send to Server, if any.
  // update the model if user role is meant for "MAHASISWA".
  useEffect(() => {
    const copyData = Object.assign(
      { ...data?.data },
      {
        credit: removeTrailingZero(data?.data?.credit),
        debit: removeTrailingZero(data?.data?.debit),
        balance: removeTrailingZero(data?.data?.balance),
      }
    );
    setDataImportMutasiBank({ ...copyData });
  }, [data]);

  return (
    <AdminLayout>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Header title="Detail Mutasi Bank" />
        </div>
      </div>
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          dataImportMutasiBank={dataImportMutasiBank}
          setDataImportMutasiBank={setDataImportMutasiBank}
          formDisable={true}
          isLoading={isLoading}
          isError={isError}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = (props) => {
  const {
    isLoading,
    isError,
    dataImportMutasiBank,
    setDataImportMutasiBank,
    formDisable,
  } = props;

  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading</p>
      ) : (
        <Form>
          <Row>
            {isError ? "something error" : null}
            <Col md={12} className="mb-3">
              <Form.Group id="datetime">
                <Form.Label>Tanggal Transaksi</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="-"
                  name="datetime"
                  disabled={true}
                  value={moment(dataImportMutasiBank.datetime).format(
                    "DD MMM YYYY HH:mm:ss"
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="description">
                <Form.Label>Deskripsi</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="-"
                  name="description"
                  disabled={formDisable}
                  value={dataImportMutasiBank.description || ""}
                  onChange={(e) =>
                    setDataImportMutasiBank({
                      ...dataImportMutasiBank,
                      description: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="debit">
                <Form.Label>Debet</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="0"
                  name="debit"
                  disabled={formDisable}
                  value={formatNumber(dataImportMutasiBank.debit || "")}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="credit">
                <Form.Label>Kredit</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="0"
                  name="credit"
                  disabled={formDisable}
                  value={formatNumber(dataImportMutasiBank.credit || "")}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="balance">
                <Form.Label>Balance</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="0"
                  name="balance"
                  disabled={formDisable}
                  value={formatNumber(dataImportMutasiBank.balance || "")}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="reff">
                <Form.Label>Reff</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="-"
                  name="reff"
                  disabled={formDisable}
                  value={dataImportMutasiBank.reff || ""}
                  onChange={(e) =>
                    setDataImportMutasiBank({
                      ...dataImportMutasiBank,
                      reff: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            {formDisable && dataImportMutasiBank.created_at ? (
              <Col md={12} className="mb-3">
                <Form.Group id="created_at">
                  <Form.Label>Tanggal Dibuat</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="created_at"
                    disabled={true}
                    value={moment(dataImportMutasiBank.created_at).format(
                      "DD MMM YYYY HH:mm:ss"
                    )}
                  />
                </Form.Group>
              </Col>
            ) : null}
          </Row>
        </Form>
      )}
    </Card.Body>
  );
};

export default FormImportMutasiBankPage;
